import { ShiftsEnum } from "@gtpl/shared-models/common-models";
import { Column, CreateDateColumn, Entity, OneToMany, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { PeelingSamples } from "./peeling-samples.entity";

@Entity('peeling')
export class Peeling {
    @PrimaryGeneratedColumn('increment', {
        name: 'peeling_id',
    })
    peelingId: number;

    @Column("varchar", {
        nullable: false,
        length: 30,
        name: "lot_number",
    })
    lotNumber: string;

   

    @Column('int', {
        name: 'saleOrder_Id'
    })
    saleOrderId: number

    @Column('int', {
        name: 'saleorder_item_id'
    })
    saleOrderItemId: number


    @Column({
        nullable: true,
        name: 'peeling_date',
    })
    peelingDate: Date;

    @Column({
        type: 'enum',
        enum: ShiftsEnum,
        nullable: true,
        name: 'shift'
    })
    shift: ShiftsEnum;

    @Column("boolean", {
        nullable: false,
        default: true,
        name: "is_active"
    })
    isActive: boolean;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;


    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

    @OneToMany(type => PeelingSamples, samples => samples.peelingInfo, { cascade: true })
    peelingSamplesInfo: PeelingSamples[];
}